// Shared "is this text a JSON array?" helpers used by the rules editors,
// submit validation, and payload builder.

export const isJsonArrayText = (text: string): boolean => {
    try {
        return Array.isArray(JSON.parse(text));
    } catch {
        return false;
    }
};

export const parseJsonArray = (text: string): unknown[] => {
    try {
        const parsed = JSON.parse(text);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};
